import { store } from '@/store';
import { getModule } from 'vuex-module-decorators';
import HelpCenterStore from '@/help-center/store';
import LoanStore from '@/loan/store';
import { LoanAPIService } from '@/loan/services/api';

const helpCenterStore = getModule(HelpCenterStore, store);
const loanStore = getModule(LoanStore, store);

export const loanHelpCenterFAQResolver = async (): Promise<void> => {
	const { isFAQContentSet } = helpCenterStore;

	if (!isFAQContentSet) {
		const content = await LoanAPIService.getHelpCenterFAQContent();
		const { fiContactInfo, orderedHelpCenterFAQTopicIds } = loanStore;

		helpCenterStore.setFAQContent(content);
		helpCenterStore.setFiContactInfo(fiContactInfo);
		await helpCenterStore.orderFAQTopics(orderedHelpCenterFAQTopicIds);
	}
};
